import React, { selectRelations , parsePesel} from 'react';

const UsersForm = ({ status, el }) => {

    function formatData(data){
        let newData = data.split(' ');
        let newDatapase = newData[0].split('/');
        return  newDatapase[1] + '.' + newDatapase[0] + '.' + newDatapase[2]
    }

    function selectRelations(el) {
        switch (el.participantRelationsDVID) {
            case 1:
                return 'Opiekun prawny';
                break;
            case 2:
                return 'Rodzice';
                break;
            case 3:
                return 'Rodzeństwo';
                break;
            case 4:
                return 'Podopieczny';
                break;
            case 5:
                return 'Dziecko';
                break;
        }
    }
 
   return status ? (
        <div id="results" className="search-results">
            <div>
                <div className="form__row">
                    <h5 className="form__label">RELACJA</h5>
                    <span id="profile-related-01-relationship" className="text-large fw-700">
                        {selectRelations(el)}
                    </span>
                </div>
                <div className="form__row">
                    <h5 className="form__label">Imię</h5>
                    <span id="profile-related-01-fname" className="text-large fw-700">
                        {el.firstName}
                    </span>
                </div>
                <div className="form__row">
                    <h5 className="form__label">Nazwisko</h5>
                    <span id="profile-related-01-lname" className="text-large fw-700">
                        {el.lastName}
                    </span>
                </div>
                <div className="form__row">
                    <h5 className="form__label">Płeć</h5>
                    <span id="profile-related-01-gender" className="text-large fw-700">
                        {(el.genderDVID == 1)? 'Mężczyzna': (el.genderDVID == 2)?'Kobieta': 'Inna'}
                    </span>
                </div>
                <div className="form__row">
                    <h5 className="form__label">PESEL</h5>
                    <span id="profile-related-01-pesel" className="text-large fw-700">
                        {el.pesel}
                    </span>
                </div>
                <div className="form__row">
                    <h5 className="form__label">Data urodzenia</h5>
                    <span id="profile-related-01-bday" className="text-large fw-700">
                        {formatData(el.dateOfBirdth)}
                        {/* {el.dateOfBirdth} */}
                    </span>
                </div>
                <div className="form__row">
                    <h5 className="form__label">Ulica</h5>
                    <span id="profile-related-01-street" className="text-large fw-700">
                        {el.street}
                    </span>
                </div>
                <div className="form__row form__row--home-numbers">
                    <div>
                        <h5 className="form__label">Nr domu</h5>
                        <span id="profile-related-01-house" className="text-large fw-700">
                            {el.building}
                        </span>
                    </div>
                    <div>
                        <h5 className="form__label">Nr mieszkania</h5>
                        <span id="profile-related-01-flat" className="text-large fw-700">
                            {el.flat}
                        </span>
                    </div>
                </div>
                <div className="form__row">
                    <h5 className="form__label">Miejscowość</h5>
                    <span id="profile-related-01-city" className="text-large fw-700">
                        {el.city}
                    </span>
                </div>
                <div className="form__row">
                    <h5 className="form__label">Kod pocztowy</h5>
                    <span id="profile-related-01-zipcode" className="text-large fw-700">
                        {el.postalCode}
                    </span>
                </div>
                <div className="form__row">
                    <h5 className="form__label break-word">E-mail</h5>
                    <span id="profile-related-01-email" className="text-large fw-700">
                        {el.email}
                    </span>
                </div>
                <div className="form__row">
                    <h5 className="form__label">Nr telefonu</h5>
                    <span id="profile-related-01-phone" className="text-large fw-700">
                        {el.phone}
                    </span>
                </div>
                <div className="form__row">
                    <p className="checkbox-group">
                        <input
                            type="checkbox"
                            id="profile-related-01-agreement"
                            name="profile-related-01-agreement"
                            className="form__checkbox"
                            checked={el.personalDataProcessingConsent}
                            disabled
                        />
                        <span className="form__label--checkbox">
                            Wyrażam zgodę na przetwarzanie moich danych osobowych w celach
                            marketingowych promujących towary i usługi Administratora, a także w
                            celach promujących towary i usługi podmiotów z Grupy EDS.
                        </span>
                    </p>
                    <p className="checkbox-group">
                        <input
                            type="checkbox"
                            id="profile-related-01-regulations"
                            name="profile-related-01-regulations"
                            className="form__checkbox"
                            checked={el.personalDataProcessingConsent}
                            disabled
                        />
                        <span className="form__label--checkbox">
                            Akceptuję{' '}
                            <a href="https://taniec.com.pl/ch/regulamin/" className="text-link" target="_blank" rel="noopener">
                                Regulamin
                            </a>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    ) : (
        ''
    );
};
export default UsersForm;
